import React from 'react';
import classes from "./BlankPage.module.css";
import Image from "../../assets/images/logo.png";

export default function BlankPage() {
  return (
    <div className={classes.mainClass}>
        <img src={Image} alt="logo" />
    </div>
  )
}
